export default [
  {
    name: 'project_contributions_list',
    component_path: 'modules/templates/blocks/project/ProjectContributionsList',
  }
]